module.exports = __webpack_public_path__ + "img/text-con-3.fbe28bb6.png";